module.exports = __webpack_public_path__ + "static/m_hero_art@2x-a9b14e6297d02954eb563c9935295193.png";